export { formatMoney, initials as initialsOf, uid } from "@cliqsuite/ui";

export function nowClock(): string {
  return new Date().toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
}

export function startOfTodayIso(): string {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

// sales.orders.order_type -> what staff actually see. "counter" is stored
// as-is (no data/migration change) — it's just an immediate-pay, no-kitchen
// sale under the hood, so "Quick Sale" is the label that matches what the
// till does with it, distinct from "Pickup" (which is sent to the kitchen
// first and paid after).
const ORDER_TYPE_LABEL: Record<string, string> = {
  counter: "Quick sale",
  pickup: "Pickup",
  dine_in: "Dine-in",
  online: "Online",
};

export function orderTypeLabel(orderType: string): string {
  return ORDER_TYPE_LABEL[orderType] ?? orderType.replace("_", " ");
}

/**
 * The real URL a table's QR code encodes — apps/guest-portal's
 * table/$qrToken route resolves it and drops the guest straight into the
 * menu with their table pre-selected. Returns null when
 * VITE_GUEST_PORTAL_URL isn't configured, so callers can show a "not
 * configured" state instead of a broken code.
 */
export function guestPortalTableUrl(storeId: string, qrToken: string): string | null {
  const base = import.meta.env.VITE_GUEST_PORTAL_URL;
  if (!base) return null;
  return new URL(`/store/${storeId}/table/${qrToken}`, base).toString();
}

/** The web receipt a customer opens by scanning the done screen's QR (Guest Portal /r/:orderId).
 * Null when VITE_GUEST_PORTAL_URL isn't configured. */
/** Where a customer joins this store's rewards on their own phone: the register shows it as a QR. */
export function guestPortalRewardsUrl(storeId: string): string | null {
  const base = import.meta.env.VITE_GUEST_PORTAL_URL;
  if (!base) return null;
  return new URL(`/store/${storeId}/loyalty`, base).toString();
}

export function receiptUrl(orderId: string): string | null {
  const base = import.meta.env.VITE_GUEST_PORTAL_URL;
  if (!base) return null;
  return new URL(`/r/${orderId}`, base).toString();
}
